export default {
  theme: {
    light: "Жарық",
    dark: "Қараңғы",
    switchToLight: "Жарық тақырыпты қосу",
    switchToDark: "Қараңғы тақырыпты қосу",
  },
  routes: {
    title: "Маршруттар",
    viewList: "Тізіммен",
    viewMap: "Картада",
    count: "Маршруттар: {n}",
    empty: "Сүзгілерге сәйкес келетін ештеңе жоқ",
    reset: "Сүзгілерді тазалау",
    gradeFilter: "Күрделілік сүзгісі",
    durationFilter: "Ұзақтығы",
    shape: { label: "Пішіні", loop: "Айналма", linear: "Бір бағытта" },
    source: { label: "Дереккөз", all: "Барлығы", curated: "EcoWay", community: "Пайдаланушылардан", communityBadge: "Пайдаланушыдан · EcoWay тексермеген", verified: "EcoWay тексерген", unverified: "Пайдаланушыдан, EcoWay тексермеген", author: "Автор", unverifiedShort: "EcoWay тексермеген" },
    distanceLabel: "Қашықтық:",
    distanceFromYou: "сізден",
  },
  safety: {
    nearestShelters: "Жақын паналар",
    nearestSheltersHint: "Сізге ең жақын МЧС құтқару үйшіктері.",
    sheltersQuery: "Құтқару үйшіктері",
    title: "Қауіпсіздік",
    loggedOutTitle: "Шығуларды тіркеу үшін кіріңіз",
    loggedOutBody: "Шығуды тіркеу жақындарыңыз бен құтқарушыларға қайда барғаныңызды және қашан оралатыныңызды хабарлайды.",
    noTrip: "Белсенді шығу жоқ",
    registerCta: "Шығуды тіркеу",
    returnBy: "қайту уақыты",
    timeLeft: "Қалды",
    overdue: "Бақылау уақыты өтті",
    overdueFor: "Кешігу",
    daysShort: "к",
    history: "Шығулар тарихы",
    call112: "112-ге қоңырау шалу",
  },
  filters: {
    label: "Жылдам сүзгілер",
    short: "Жарты күн",
    day: "Толық күн",
    multi: "Көпкүндік",
    easy: "Жеңіл T1–T2",
  },
  ui: {
    gradeAria: "Күрделілік T{n}",
  },
  common: {
    previous: "Алдыңғы",
    next: "Келесі",
    close: "Жабу",
    comingSoon: "Функционал әзірленуде",
    loading: "Жүктелуде…",
    dismissLabel: "Тазарту",
  },

  news: {
    title: "Не жаңа",
    backToApp: "Қолданбаға оралу",
    backToArchive: "Барлық жаңартулар",
    empty: "Әзірге жаңартулар жоқ",
    loadError: "Жүктеу мүмкін болмады",
    showMore: "Тағы көрсету",
    notFoundTitle: "Құжат табылмады",
    notFoundBody: "Сілтеме ескірген болуы мүмкін.",
    accept: "Қабылдау",
    accepted: "Қабылданды",
    acceptError: "Қабылдау мүмкін болмады, қайталап көріңіз",
    loginToAccept: "Құжатты қабылдау үшін кіріңіз",
    outdated: "Бұл құжаттың ескірген нұсқасы.",
    openLatest: "Өзекті нұсқасын ашу",
  },
  notifications: {
    filterAll: "Барлығы",
    filterUnread: "Оқылмаған",
    emptyUnread: "Оқылмаған хабарландырулар жоқ",
    unreadDot: "Оқылмаған хабарландырулар бар",
    caption: "Маршруттарыңыз бойынша оқиғалар және сервис жаңалықтары",
    markAllRead: "Барлығын оқылды деп белгілеу",
    showMore: "Тағы көрсету",
    emptyTitle: "Әзірге жаңалық жоқ",
    emptyBody: "Мұнда пікірлер, оралу туралы еске салулар және EcoWay жаңалықтары көрінеді.",
    loading: "Жүктелуде...",
    accept: "Қабылдау",
    unknown: "Хабарландыру",
    kinds: {
      review_received: { title: "Маршрутқа жаңа пікір", body: "«{route_name}»: 5-тен {stars}" },
      registration_soon: { title: "Оралу уақыты жақындады", body: "«{route_name}»: {expected_return_at} дейін оралыңыз" },
      registration_overdue: { title: "Оралу уақыты өтті", body: "«{route_name}»: {expected_return_at} дейін күтілген. Оралғаныңызды белгілеңіз" },
      hello_published: { title: "Сәлеміңіз жарияланды" },
      feedback_new: { title: "Кері байланыста жаңа өтініш" },
      hello_request_new: { title: "Сәлемге жаңа өтінім", body: "Кімнен: {submitter_name}" },
      security_digest: { title: "Сағат ішіндегі қауіпсіздік оқиғалары: {count}" },
      glitchtip_digest: { title: "Сағат ішіндегі жаңа қателер: {count}" },
    },
  },
  app: {
    skipToContent: "Мазмұнға өту",
    navLabel: "Негізгі навигация",
    profileButton: { guest: "Кіру және профильді ашу", user: "Менің профилім" },
    tabs: { safety: "Қауіпсіздік", me: "Мен", map: "Маршруттар", live: "Live", explore: "Шолу", profile: "Профиль", admin: "Әкімші" },
    feedbackButton: "Кері байланыс",
    sidebar: { show: "Панельді көрсету", hide: "Панельді жасыру" },
    mapLoading: "Карта жүктелуде…",
    footer: { copyright: "© {year} EcoWay · жоба операторы: «ORTRA» ЖШС · Қазақстан" },
    install: {
      title: "EcoWay қолданбасын орнату",
      subtitle: "Қолданба ретінде негізгі экраннан жылдам қатынас",
      installButton: "Орнату",
      dismissLabel: "Жабу",
      iosInstructions: "Safari экранының төменгі жағындағы «Бөлісу» түймесін басыңыз, содан кейін «Үй экранына қосу»",
    },
    cookieConsent: {
      title: "Біз cookie файлдарын қолданамыз",
      message: "Аккаунтқа кіру және камералардан видео көру үшін қажетті cookie файлдары қолданылады. Сіздің келісіміңізбен біз EcoWay-ды жақсарту үшін аналитиканы да қолданамыз. Таңдауды кез келген уақытта Профиль → Баптаулар бөлімінде өзгертуге болады.",
      acceptAll: "Барлығын қабылдау",
      essentialOnly: "Тек қажеттілерін",
      customize: "Баптау",
      customizeTitle: "Cookie баптаулары",
      alwaysOn: "Әрқашан қосулы",
      essential: {
        title: "Қажетті",
        description: "Аккаунтқа кіру, камералардан видео көру сеансы. Оларсыз сайт жұмыс істемейді.",
      },
      analytics: {
        title: "Аналитика",
        description: "Google Analytics — сайттың қай бөлімдері көбірек қолданылатынын түсінуге көмектеседі.",
      },
      save: "Таңдауды сақтау",
      back: "Артқа",
      dismissLabel: "Жабу",
    },
  },

  leftPanel: {
    brand: "EcoWay",
    searchPlaceholder: "Орындарды, маршруттарды, нүктелерді іздеу",
    sortLabel: "Сұрыптау",
    sort: {
      recommended: "Өзектілігі бойынша",
      distance: "Қашықтығы бойынша",
      elevation: "Биіктік жиымы бойынша",
      name: "Атауы бойынша",
      nearest: "Маған жақын",
      duration: "Уақыты бойынша",
    },
  },

  routeStatus: {
    active: "Ашық",
    draft: "Орташа",
    closed: "Жабық",
    unknown: "—",
  },

  search: {
    cancel: "Болдырмау",
    recent: "Соңғы сұраныстар",
    showMore: "Тағы көрсету",
    clearHistory: "Тазалау",
    groupPlaces: "Орындар",
    groupRoutes: "Маршруттар",
    groupPoints: "Нүктелер",
    more: "тағы {n}",
    noResults: "Ештеңе табылмады",
    loading: "Іздеуде…",
    originUser: "сізден",
    originCenter: "орталықтан",
    originToCenter: "Карта орталығынан есептеу",
    originToUser: "Сіздің орныңыздан есептеу",
    nearTo: "{name} жанында · {distance}",
    nearbyRoutes: "Жақын маңдағы маршруттар",
    example1: "Бутаковка сарқырамасы",
    example2: "Титов асуы",
    example3: "Су",
    example4: "Көлдерге маршруттар",
    recentTitle: "Соңғылар",
    noResultsHint: "Басқа атауды көріңіз немесе жазылуын тексеріңіз",
    error: "Іздеу орындалмады",
    retry: "Қайталау",
    allRoutes: "Барлық маршруттар",
    routeSubtitle: "Маршрут · {km} км",
    loadingRoutes: "Маршруттар жүктелуде…",
    routesError: "Маршруттарды жүктеу мүмкін болмады",
    elevation: "{m} м",
    kinds: { peak: "шың", volcano: "жанартау", hill: "төбе", ridge: "жота", mountain_pass: "асу", saddle: "ашу", spring: "бұлақ", drinking_water: "ауыз су", water_point: "су көзі", water_tap: "су шүмегі", water_well: "құдық", waterfall: "сарқырама", shelter: "баспана", alpine_hut: "тау үйшігі", wilderness_hut: "саяжай үйшік", camp_site: "лагерь", mountain_rescue: "құтқару бекеті", rescue_hut: "құтқару үйшігі", viewpoint: "көрініс алаңы", parking: "тұрақ", danger: "қауіпті бөлік", lake: "көл", water: "су айдыны", glacier: "мұздық", village: "ауыл", town: "қала", city: "қала", hamlet: "шағын ауыл", locality: "жер", firepit: "алау орны", picnic_table: "пикник үстелі", toilets: "дәретхана", cave_entrance: "үңгір кіреберісі", rock: "жартас", tower: "мұнара", cable_car_station: "аспалы жол бекеті", ford: "өткел", grassland: "шалғын", wetland: "батпақ", suburb: "аудан", neighbourhood: "шағын аудан", valley: "алқап", gorge: "шатқал", region: "аймақ" },
  },

  point: {
    back: "Артқа",
    close: "Карточканы жабу",
    loading: "Нүкте жүктелуде…",
    notFound: "Нүкте табылмады",
    notFoundHint: "Мүмкін, ол жасырылған немесе жойылған. Артқа оралыңыз.",
    error: "Нүктені жүктеу мүмкін болмады",
    nearbyPoints: "Жақын нүктелер",
  },

  poiTypes: {
    start: "Старт",
    finish: "Финиш",
    "night-stop": "Түнеу",
    "via-point": "Жол нүктесі",
    water: "Су (бұлақ)",
    danger: "Қауіпті учаске",
    viewpoint: "Шолу алаңы",
    note: "Ескертпе",
    "rest-stop": "Тоқтау орны",
    junction: "Айрық",
    shelter: "Пана",
    parking: "Автотұрақ",
  },

  units: {
    km: "км",
    m: "м",
    decimal: ",",
    h: "сағ",
    min: "мин",
    ms: "м/с",
    hpa: "гПа",
    mm: "мм",
    mmhr: "мм/сағ",
    wm2: "Вт/м²",
  },

  reviews: {
    noRatings: "Әзірге баға жоқ",
    dialogTitle: "Сіздің пікіріңіз",
    yourRating: "Сіздің бағаңыз",
    commentLabel: "Пікір (міндетті емес)",
    commentPlaceholder: "Соқпақ, су, ауа райы қалай болды?",
    submit: "Жіберу",
    delete: "Пікірді жою",
    error: "Пікірді сақтау мүмкін болмады. Қайталап көріңіз.",
    count: "Бағалар: {n}",
    showMore: "Тағы көрсету",
    ctaTitle: "Бұл маршрутпен өттіңіз бе?",
    mineTitle: "Сіздің пікіріңіз",
    showAll: "Барлық пікірлер ({n})",
    ctaText: "Соқпақ, су, ауа райы қалай болғанымен бөлісіңіз.",
    mineText: "Сіз бұл маршрутқа баға бергенсіз.",
    cta: "Пікір қалдыру",
    edit: "Пікірді өзгерту",
  },
  routeDetails: {
    actionsLabel: "Маршрут әрекеттері",
    conditionsNow: "Қазір: {name}, {km} км",
    plate: { loss: "Түсу", distance: "Қашықтық", gain: "Көтерілу", max: "Биіктік", time: "Уақыт" },
    back: "Артқа",
    close: "Карточканы жабу",
    eyebrow: "Маршрут",
    description: "Сипаттама",
    descriptionMore: "Толығырақ",
    descriptionLess: "Жасыру",
    weatherShort: "Ауа райы",
    shareMenu: { link: "Сілтемемен бөлісу" },
    gettingThere: { title: "Бастауға қалай жетуге болады", copy: "Координаттарды көшіру", copied: "Координаттар көшірілді", open2gis: "2GIS-те ашу", openGoogleMaps: "Google Карталарында ашу" },
    maxElevation: "макс.",
    stats: {
      distanceHint: "Маршрут қашықтығы",
      gainHint: "Биіктік жиымы",
      lossHint: "Биіктік жоғалту",
      maxElevationHint: "Маршруттағы ең биік нүкте",
    },
    timeInTransit: "Жолда өткізетін уақыт — нақтыланады",
    estimatedTimeDisclaimer: "Болжамды жол уақыты, жарты сағатқа дейін жоғары қарай дөңгелектенген (трек қашықтығы мен беткейіне негізделген, Тоблер формуласы). Дене дайындығын, жүктің салмағын және ауа-райын ескермейді — нақты уақыт айтарлықтай өзгеше болуы мүмкін.",
    like: "Ұнату",
    format: {
      label: "Формат",
      loop: "Шеңберлі",
      linear: "Сызықтық",
      halfDay: "Жарты күн",
      fullDay: "Бүтін күн",
      returnNote: "Сол жолмен қайту",
    },
    actions: {
      registerFull: "Тіркеу",
      save: "Сақтау",
      saved: "Сақталды",
      saveLoginRequired: "Маршруттарды сақтау үшін жүйеге кіріңіз",
      likeLoginRequired: "Ұнату үшін кіріңіз",
      share: "Бөлісу",
      register: "Тіркелу",
      download: "Жүктеп алу",
    },
    elevationProfile: "Биіктік профилі",
    elevationProfileAria: "Маршруттың биіктік профилі",
    elevationProfileCursorAria: "Маршруттың биіктік профилі — маршрутқа нүкте қою үшін басыңыз немесе сүйреңіз",
    days: "Маршрут бойынша күндер",
    dayWord: { one: "күн", few: "күн", many: "күн" },
    weather: {
      title: "Маршрут ауданындағы ауа райы",
      loading: "Болжам жүктелуде…",
      windUpTo: "Жел жылдамдығы",
      forecastSource: "Болжам · open-meteo.com",
      unavailable: "Бұл аймаққа ауа райы болжамы қолжетімсіз",
      infoTitle: "Бұл ауа райы қайдан алынған?",
      infoText: "Ауа райы бүкіл маршрут бойынша орташаланған, нақты бір нүктеге байланбаған. Ұзақ маршруттарда әртүрлі учаскелер мен биіктіктердегі жағдай көрсетілген болжамнан айтарлықтай өзгеше болуы мүмкін.",
    },
    risks: {
      title: "Маусымдық тәуекелдер",
      text: "Көлеңкелі жерлерде таңертең мұз болуы мүмкін, жауын-шашыннан кейін — батпақ пен сырғанақ тастар.",
    },
    feedbackCta: {
      text: "Дәлсіздік байқадыңыз ба немесе маршрутты немен толықтыруға болатынын білесіз бе? Хабарлама жіберіңіз — біз ақпаратты тексеріп, пайдалы өзгерістер қосамыз.",
      button: "Хабарлама жіберу",
    },
    tabs: {
      label: "Карточка бөлімдері",
      days: "Күндер",
      overview: "Шолу",
      reviews: "Пікірлер",
      photos: "Фото",
      soon: "жақында",
    },
    gpxModal: {
      disclaimer: "Маршрут пен трек тек навигациялық сипатта. Жергілікті жерде алшақтықтар болуы мүмкін — нақты жағдайға, белгілерге және ортаға назар аударыңыз.",
      downloadButton: "GPX жүктеу",
    },
    selectRoute: "Маршрутты таңдаңыз",
    toast: {
      saved: "Сақталғандарға қосылды",
      linkCopied: "Сілтеме көшірілді",
    },
    grade: {
      1: "Оңай",
      2: "Қарапайым",
      3: "Орташа",
      4: "Күрделі",
      5: "Өте күрделі",
      6: "Экстремалды",
    },
    weatherCode: {
      "0": "Ашық",
      "1": "Аздап бұлтты",
      "2": "Ауыспалы бұлттылық",
      "3": "Бұлтты",
      "45": "Тұман",
      "48": "Аяз тұман",
      "51": "Жеңіл жаңбыр",
      "53": "Жеңіл жаңбыр",
      "55": "Күшті дымқыл",
      "61": "Жаңбыр",
      "63": "Жаңбыр",
      "65": "Күшті жаңбыр",
      "66": "Мұзды жаңбыр",
      "67": "Мұзды жаңбыр",
      "71": "Қар",
      "73": "Қар",
      "75": "Күшті қар",
      "77": "Қар түйіршігі",
      "80": "Нөсер",
      "81": "Нөсер",
      "82": "Күшті нөсер",
      "85": "Қар жаууы",
      "86": "Күшті қар жаууы",
      "95": "Найзағай",
      "96": "Бұршақты найзағай",
      "99": "Бұршақты найзағай",
    },
    advisory: {
      snow: "Қар жаууы мүмкін — биікте жылы киім алыңыз және сырғанақ учаскелерге дайын болыңыз.",
      rain: "Жаңбыр жаууы мүмкін — тропа сырғанақ болуы мүмкін, жаңбырдан кейін батпақ күтіңіз.",
      storm: "Найзағай қаупі — ашық жоталар мен шыңдардан аулақ болыңыз.",
      fog: "Тұман болуы мүмкін — маршруттағы көрінім шектелуі мүмкін.",
      none: "Елеулі ауа райы тәуекелдері күтілмейді.",
    },
    day: { today: "Бүгін", tomorrow: "Ертең" },
  },

  gradeModal: {
    title: "Күрделілік нені білдіреді?",
    close: "Жабу",
    subtitle: "T1 (қарапайым) бастап T6 (экстремалды) дейінгі шкала",
    thisRoute: "осы маршрут",
    footer: "T1–T6 күрделілігі техникалық күрделілікті сипаттайды. Ол ауа райын, маусымды және дайындығыңызды бағаламайды.",
    descriptions: {
      1: "Жақсы тропамен немесе жолмен қарапайым серуен. Жаңадан бастаушыларға және сабырлы серуендерге қолайлы.",
      2: "Байқалатын тропамен күрделі емес тау маршруты. Өрлеулер, тастар немесе тегіс емес бедер мүмкін.",
      3: "Талап қоятын тау маршруты. Сенімді жүру, қалыпты дене дайындығы және ауа райына назар аудару қажет.",
      4: "Альпілік жаяу маршрут. Тік учаскелер, сусыма тас, қар, нашар тропа және сенімді бағдарлау қажеттілігі мүмкін.",
      5: "Күрделі бедері, экспозициясы және айқын тропасыз учаскелері бар қиын альпілік маршрут. Жақсы тәжірибе қажет.",
      6: "Көбіне тропасыз, айқын экспозициясы және қиын бедері бар өте күрделі альпілік жаяу маршрут. Үздік тәжірибе, бағдарлау және жоғары дайындық қажет.",
    },
  },

  login: {
    title: "EcoWay-ге кіру",
    subtitle: "Маршруттарды қадағалаңыз және хабарландырулар алыңыз",
    email: "Email немесе телефон",
    password: "Құпия сөз",
    passwordPlaceholder: "Құпия сөзді енгізіңіз",
    confirmPassword: "Құпия сөзді растаңыз",
    passwordMismatch: "Құпия сөздер сәйкес келмейді",
    passwordHint: "Кемінде 8 таңба",
    showPassword: "Құпия сөзді көрсету",
    hidePassword: "Құпия сөзді жасыру",
    cancel: "Бас тарту",
    submitLoading: "Кіру…",
    submit: "Кіру",
    errorInvalid: "Email/телефон немесе құпия сөз қате",
    errorGeneric: "Кіру мүмкін болмады. Кейінірек қайталап көріңіз.",
    orDivider: "немесе",
    emailToggle: "Email арқылы кіру",
    loginWithCode: "Код арқылы кіру",
    loginWithPassword: "Құпия сөз арқылы кіру",
    changeNumber: "Нөмірді өзгерту",
    sendCode: "Кодты жіберу",
    sendCodeLoading: "Жіберілуде…",
    verifyCode: "Растау",
    verifyCodeLoading: "Тексерілуде…",
    otpCodeLabel: "WhatsApp коды",
    otpInvalid: "Код қате немесе мерзімі өтіп кеткен",
    otpRateLimited: "Тым көп әрекет. Кейінірек қайталап көріңіз.",
    invalidPhone: "Телефон нөмірін дұрыс енгізіңіз",
    optionalEmailLabel: "Email (міндетті емес)",
    optionalEmailHint: "Сол құпия сөзбен email арқылы да кіре аласыз",
    phoneOtpStepTitle: "WhatsApp кодын енгізіңіз",
    phoneOtpStepSubtitle: "{phone} нөміріне код жібердік",
    phonePasswordStepTitle: "Құпия сөз жасаңыз",
    phonePasswordStepSubtitle: "Телефон расталды — кіру үшін құпия сөз орнатыңыз",
    telegramWeb: "Telegram Web арқылы кіру",
    telegramApp: "Telegram қосымшасы арқылы кіру",
    telegramWaiting: "Telegram-ды ашып, Start басыңыз",
    telegramWaitingHint: "Растаудан кейін бет автоматты түрде жаңарады",
    telegramOpen: "Telegram-ды ашу",
    telegramRetry: "Қайталап көру",
    telegramLinkConflict: "Бұл Telegram басқа аккаунтқа байланыстырылған",
    telegramGenericError: "Telegram арқылы кіру мүмкін болмады. Қайталап көріңіз.",
    google: "Google арқылы кіру",
    telegramOidc: "Telegram арқылы кіру",
    oauthGenericError: "Кіру мүмкін болмады. Қайта немесе басқа тәсілмен көріңіз.",
    registerToggle: "Аккаунт жоқ па? Тіркелу",
    loginToggle: "Аккаунт бар ма? Кіру",
    forgotPassword: "Құпия сөзді ұмыттыңыз ба?",
    registerTitle: "Тіркелу",
    registerSubmit: "Тіркелу",
    registerSubmitLoading: "Тіркелу…",
    registerSuccessTitle: "Поштаны тексеріңіз",
    registerSuccessBody: "{email} мекенжайына растау сілтемесі бар хат жібердік",
    registerErrorGeneric: "Тіркелу мүмкін болмады. Кейінірек қайталап көріңіз.",
    emailNotVerifiedError: "Пошта расталмаған — хатты қайта жібердік",
    forgotTitle: "Құпия сөзді қалпына келтіру",
    forgotSubtitle: "Email енгізіңіз — құпия сөзді қалпына келтіру сілтемесін жібереміз",
    forgotSubmit: "Сілтеме жіберу",
    forgotSubmitLoading: "Жіберілуде…",
    forgotSuccessBody: "{email} мекенжайында құпия сөзі бар аккаунт болса, хат жіберілді",
    backToLogin: "Кіруге оралу",
  },

  conflict: {
    title: "Бұл сіз бе?",
    subtitle: "Бұл кіру тәсілі осы профильге бұрыннан байланыстырылған. Бұл сіз екеніңізді растау және жаңа тәсілді байланыстыру үшін кіріңіз.",
    loginWithPassword: "Email/телефон және құпия сөзбен кіру",
    cancel: "Бас тарту",
    success: "Дайын! Кіру тәсілі байланыстырылды.",
    error: "Байланыстыру мүмкін болмады. Қайталап көріңіз.",
  },

  oauthCallback: {
    processing: "Кіру…",
    linkedTitle: "Дайын",
    linkedBody: "Кіру тәсілі профиліңізге байланыстырылды",
    errorTitle: "Кіру мүмкін болмады",
    errorBody: "Қайталап көріңіз немесе басқа тәсілді қолданыңыз",
    browserMismatch: "Кіру басқа браузерде басталған. Осы құрылғыда қайта бастаңыз.",
    identityAlreadyLinked: "Бұл аккаунт басқа EcoWay профиліне тіркелген. Сол профиль арқылы кіріңіз немесе алдымен ол жерден ажыратыңыз.",
    providerAlreadyLinked: "Осы түрдегі кіру тәсілі профиліңізге бұрыннан тіркелген",
    backToMap: "Картаға",
    backToProfile: "Профильге",
  },

  emailVerify: {
    processing: "Пошта расталуда…",
    successTitle: "Пошта расталды",
    successBody: "Енді пошта мен құпиясөз арқылы кіріңіз.",
    errorTitle: "Сілтеме жарамсыз",
    errorBody: "Сілтеменің мерзімі өтіп кетті немесе бұрын қолданылған. Растауды қайта сұраңыз.",
    backToMap: "Картаға",
  },

  resetPassword: {
    title: "Жаңа құпия сөз",
    passwordLabel: "Жаңа құпия сөз",
    submit: "Құпия сөзді сақтау",
    submitLoading: "Сақталуда…",
    successTitle: "Құпия сөз жаңартылды",
    successBody: "Енді жаңа құпия сөзбен кіре аласыз",
    errorTitle: "Сілтеме жарамсыз",
    errorBody: "Сілтеменің мерзімі өтіп кетті немесе бұрын қолданылған. Қалпына келтіруді қайта сұраңыз.",
    login: "Кіру",
  },

  hlsPlayer: {
    unavailable: "Ағын қолжетімсіз",
    stillWatching: "Әлі қарап отырсыз ба?",
    continue: "Жалғастыру",
  },

  videoControls: {
    play: "Ойнату",
    pause: "Кідірту",
    mute: "Дыбысты өшіру",
    unmute: "Дыбысты қосу",
    fullscreen: "Толық экран",
    seek: "Айналдыру",
  },

  live: {
    cameraAlt: "«{name}» камерасының суреті",
    playCamera: "Тікелей көру",
    title: "Live",
    nowTitle: "Қазір",
    nodesCount: "нүкте",
    eventsCount: "оқиға",
    lastReading: "Соңғы көрсеткіштер:",
    refresh: "Жаңарту",
    noNodes: "Қолжетімді нүктелер жоқ",
    noEvents: "Әлі жарияланған оқиғалар жоқ",
    liveBadge: "LIVE",
    privateCamera: "Жеке камера",
    close: "Жабу",
    edited: "өңд.",
    edit: "Өңдеу",
    delete: "Жою",
    postMenu: "Пост мәзірі",
    like: "Ұнату",
    composerPlaceholder: "Не жаңалық бар?",
    composerPublish: "Жариялау",
    composerSave: "Сақтау",
    composerCancel: "Бас тарту",
    addPhoto: "Фото қосу",
    removePhoto: "Фотоны өшіру",
    editPostTitle: "Постты өңдеу",
    deleteConfirm: "Бұл постты жоюсыз ба?",
    postFailed: "Постты сақтау мүмкін болмады",
    pin: "Бекіту",
    unpin: "Бекітуден алу",
    pinned: "Бекітілген",
    pinFailed: "Бекітуді өзгерту мүмкін болмады",
    pinLimitReached: "Ең көбі 2 элементті бекітуге болады",
    attachVideo: "Видео тіркеу",
    removeVideo: "Видеоны алып тастау",
    selectVideoTitle: "Қоймадан видео таңдау",
    noAvailableVideos: "Қолжетімді видео жоқ",
    sunrise: "Күн шығуы",
    sunset: "Күн батуы",
    sunAt: "{label}: {time}",
    infoTooltip: {
      label: "Толығырақ",
      rainPossible: "Болжам шатырдағы метеостанцияның көрсеткіштері (ылғалдылық пен шық нүктесі) негізінде жасалған — жауын-шашын кепілдендірілмейді, бірақ ықтимал.",
      windy: "Тұрақты жел 8 м/с бастап — маршрутта, әсіресе ашық жерлерде, бұл сезіледі.",
      windStrong: "Тұрақты жел 15 м/с бастап — өңірдегі гидрометслужба өлшемдері бойынша қауіпті құбылыс шегі. Ашық қыраттар мен шыңдарда аса сақ болыңыз.",
      windGusty: "Ырғалдар орташа желден едәуір күшті — кенеттен серпілістер мүмкін, әсіресе ашық және биік жерлерде.",
      sunrise: "Уақыт қоршаған рельефті ескере отырып есептелген және күннің көрінетін көкжиекті нақты қашан кесіп өтетінін білдіреді. Жарық түсу бұл уақыттан ертерек басталуы мүмкін.",
      sunset: "Уақыт қоршаған рельефті ескере отырып есептелген және күннің көрінетін көкжиекті нақты қашан кесіп өтетінін білдіреді. Қараңғылық бұл уақыттан кешірек түсуі мүмкін.",
      uvLevels: {
        low: "Көпшілік үшін тәуекел төмен — арнайы қорғаныс қажет емес, ашық күні күннен қорғайтын көзілдірік жеткілікті.",
        moderate: "Тәуекел орташа — түскі уақытта көлеңкеде болған жөн, SPF 30+ кремін, бас киім мен көзілдірікті қолданыңыз.",
        high: "Күн шалу тәуекелі жоғары — SPF 30+ крем, бас киім және көзілдірік міндетті, сағат 11:00-ден 16:00-ге дейін тікелей күннен аулақ болыңыз.",
        veryHigh: "Тәуекел өте жоғары — қорғалмаған тері 15–25 минутта күйіп қалуы мүмкін. SPF 50 кремін қолданыңыз, теріні мүмкіндігінше жабыңыз, күндіз көлеңке іздеңіз.",
        extreme: "Тәуекел экстремалды — қорғалмаған тері бірнеше минутта күйіп қалуы мүмкін. Мүмкіндігінше күннен аулақ болыңыз, тығыз киім мен SPF 50+ кремін қолданыңыз.",
      },
    },
    stationDetail: {
      temp: "Темп.",
      feelsLike: "Сезіледі",
      wind: "Жел",
      windGust: "Желдің лебі",
      humidity: "Ылғал.",
      dewPoint: "Шық нүктесі",
      pressure: "Қысым",
      rainRate: "Жаңбыр",
      rainTotal: "Тәуліктік жауын",
      solar: "Күн сәулесі",
      uv: "УК индексі",
      nearbyPlaceholder: "Жақын маршруттар API-дан жүктелуде",
      compass: { n: "С", ne: "СШ", e: "Ш", se: "ОШ", s: "О", sw: "ОБ", w: "Б", nw: "СБ" },
      uvLevels: {
        low: "Төмен",
        moderate: "Орташа",
        high: "Жоғары",
        veryHigh: "Өте жоғары",
        extreme: "Экстремалды",
      },
      alerts: {
        raining: "Жаңбыр жауып тұр",
        rainPossible: "Жауын-шашын ықтимал",
        windy: "Желді",
        windStrong: "Күшті жел",
        windGusty: "Ырғалды жел",
        feelsLike: "{actual}° (сезілуі {feels}°)",
      },
      descriptions: {
        temp: "Станциядағы ауа температурасы.",
        feelsLike: "Жел салқындатуын (суық) немесе ылғалдылықты (ыстық) ескеретін сезілетін температура.",
        humidity: "Ауаның салыстырмалы ылғалдылығы.",
        dewPoint: "Ауа ылғалмен қанығатын температура.",
        wind: "Қазіргі жел жылдамдығы мен бағыты.",
        windGust: "Соңғы аралықтағы ең күшті жел лебі.",
        pressure: "Атмосфералық қысым.",
        rainRate: "Қазіргі жауын-шашын қарқыны.",
        rainTotal: "Тәулік бойы жауын-шашын мөлшері.",
        solar: "Күн радиациясының қарқыны.",
        uv: "Терінің күйіп қалу қаупі.",
      },
    },
    detailsTitle: "Барлық көрсеткіштер",
  },

  liveHome: {
    subtitle: "Геошатыр маңында дәл қазір не болып жатыр: камералар, ауа райы станциясы, таймлапстар және сәлемдер.",
    title: "Live",
    close: "Жабу",
    aboutBanner: {
      text: "EcoWay жобасы Visit Almaty, Іле-Алатау мемлекеттік ұлттық табиғи паркі және Алматы қ. ТЖД қатысуымен дамып келеді",
      button: "Жоба туралы",
    },
    timelapseFeed: {
      title: "Таймлапстар",
      descriptionPlaceholder: "Қысқаша сипаттама (міндетті емес)",
      deleteConfirm: "Бұл таймлапсты каруcельден өшіру керек пе?",
      pin: "Бекіту",
      unpin: "Босату",
      pinLimitReached: "Бір нүктеде 2-ден артық таймлапс бекітуге болмайды",
      pinFailed: "Бекітуді өзгерту сәтсіз аяқталды",
      download: "Жүктеп алу",
      editDescription: "Сипаттаманы өзгерту",
      saveDescription: "Сақтау",
      saveFailed: "Өзгерістерді сақтау сәтсіз аяқталды",
      itemMenu: "Мәзір",
      delete: "Өшіру",
    },
  },

  helloFeed: {
    title: "#ПриветEcoway",
    postCount: "Мынжылқыдан барлығы {count} сәлем",
    uploadButton: "Жариялау қосу",
    play: "Ойнату",
    remove: "Алып тастау",
    captionPlaceholder: "Жазба (міндетті емес)",
    publish: "Жариялау",
    download: "Жүктеп алу",
    deleteConfirm: "Бұл жарияланымды өшіру керек пе?",
    empty: "Әзірге жарияланымдар жоқ",
    uploadFailed: "Файлды жүктеу сәтсіз аяқталды",
    itemMenu: "Мәзір",
    editCaption: "Жазбаны өзгерту",
    saveCaption: "Сақтау",
    delete: "Өшіру",
    saveFailed: "Өзгерістерді сақтау сәтсіз аяқталды",
    wave: {
      openButton: "Келесісі сенікі",
      title: "Өз бейнесәлеміңді жібер",
      intro: "Қол бұлға, биле, таңғалдыр 🙂 Сәлден кейін бейнеашықхатың #ПриветEcoway лентасында пайда болады. Жүктеп алып, достарыңа жібер.",
      dateLabel: "Күні",
      timeLabel: "Уақыты",
      consent: "Менің қатысуыммен түсірілген видеоны өңдеуге және #ПриветEcoway-да жариялауға келісемін",
      consentLink: "Бейнесәлемдесуге келісім",
      submit: "Жіберу",
      cancel: "Болдырмау",
      successTitle: "Сәлемің қабылданды 👋.",
      successMessage: "#ПриветEcoway лентасын бақыла — бейнеашықхат онда бүгін пайда болады.",
      close: "Жабу",
      errorRequired: "Күні мен уақытын көрсет",
      errorConsent: "Жариялауға келісім қажет",
      errorFuture: "Бұл уақыт әлі болған жоқ",
      errorTooOld: "Приветтерді екі апта ішінде қараймыз",
      errorGeneric: "Өтінімді жіберу мүмкін болмады. Кейінірек қайталап көр.",
    },
  },

  explore: {
    noRoutes: "Маршруттар жоқ",
    onMap: "Картада",
    comingSoon: {
      title: "Жақында мұнда ақылды маршрут таңдау пайда болады.",
      body: "Қайда және не үшін бару керектігін айтыңыз — EcoWay сізге мақсаттарыңызға, мүмкіндіктеріңізге және көңіл-күйіңізге сай орындар мен маршруттар табуға көмектеседі.",
    },
  },

  feedback: {
    form: {
      title: "Кері байланыс",
      message: "Хабарлама",
      messagePlaceholder: "Не болғанын немесе нені жақсартуға болатынын сипаттаңыз",
      images: "Фотосуреттер",
      addImage: "Фото қосу",
      removeImage: "Фотоны өшіру",
      imagesHint: "{max} фотоға дейін, әрқайсысы {mb} МБ-тан аспауы керек",
      tooManyImages: "Ең көбі {max} фото тіркеуге болады",
      imageTooLarge: "«{name}» файлы {mb} МБ-тан үлкен",
      contactName: "Аты",
      contactNamePlaceholder: "Міндетті емес",
      contactPhone: "Телефон",
      contactEmail: "Email",
      messengerConsent: "Менімен {provider} арқылы хабарласуға келісемін",
      submit: "Жіберу",
      errorGeneric: "Хабарлама жіберілмеді. Қайталап көріңіз.",
    },
    success: {
      title: "Рахмет!",
      message: "Хабарламаңыз қабылданды, оны міндетті түрде қарастырамыз.",
    },
  },

  profile: {
    markers: { emptyTitle: "Әзірге белгі жоқ", empty: "Картаға «Белгі» құралымен нүкте қойып, оны өзіңізге сақтаңыз.", onMap: "Картада", show: "Картада көрсету", hide: "Картадан жасыру" },
    title: "Профиль",
    loginPrompt: "Аккаунтқа кіріңіз",
    loginSubtitle: "Маршруттарды қадағалаңыз және хабарландырулар алыңыз",
    loginButton: "Кіру",
    editButton: "Профильді өзгерту",
    sections: {
      notifications: "Хабарландырулар",
      saved: "Сақталғандар",
      markers: "Менің белгілерім",
      trail: "Менің жолым",
      collection: "Менің маршруттарым",
      safety: "Қауіпсіздік",
      settings: "Баптаулар",
    },
    trail: {
      caption: "Алматы тауларындағы жеке прогресс",
      distance: "жүрілді",
      gain: "жиым",
      routesCount: "маршрут",
      locationsCount: "локация",
      highestPoint: "ең биік нүкте",
      lastRouteTileEarned: "соңғы",
      lastRouteTileEmpty: "бос",
      lastRouteCardLabel: "Соңғы маршрут",
      emptyNote: "Маршрутты сақтап, оны өтіңіз — осында статистика пайда болады",
    },
    collection: {
      caption: "Сіздің маршруттарыңыз және каталогтан сақталғандар",
      tabs: { mine: "Менікі", saved: "Сақталғандар" },
      mineEmptyNote: "Картадағы редакторда алғашқы маршрутыңызды сызыңыз, ол осында пайда болады",
      card: {
        public: "Жария маршрут, барлығына көрінеді",
        private: "Жеке маршрут, тек сізге көрінеді",
        makePublic: "Жария ету",
        makePrivate: "Жеке ету",
        views: "Қаралымдар",
        likes: "Ұнатулар",
        saves: "Сақтаулар",
        share: "Бөлісу",
        edit: "Өңдеу",
      shareDisabled: "Бөлісу үшін маршрутты жария етіңіз",
      delete: "Маршрутты жою",
      deleteConfirmTitle: "«{name}» маршрутын жою керек пе?",
      deleteConfirmBody: "Маршрут пен оның пікірлері біржола жойылады.",
      deleted: "Маршрут жойылды",
      deleteError: "Маршрутты жою мүмкін болмады",
      deleteCancel: "Бас тарту",
        nowPublic: "Маршрут жария болды",
        nowPrivate: "Маршрут жеке болды",
        visibilityError: "Құпиялылықты өзгерту мүмкін болмады",
        linkCopied: "Сілтеме көшірілді",
      },
      completedEmptyNote: "Өтілген маршруттар жорық аяқталғаннан кейін осында пайда болады",
      savedEmptyNote: "Сақталған маршруттар осында пайда болады",
    },
    safety: {
      caption: "Шығуларыңызды тіркеп, маршрут жоспарын жақындарыңызбен бөлісіңіз — бұл жорық алдындағы қарапайым базалық қауіпсіздік шарасы.",
      activeTripLabel: "Белсенді / жақындағы жорық",
      noActiveTrip: "Тіркелген жорықтар жоқ",
      noActiveTripHint: "Шығар алдында маршрутты тіркеңіз",
      emergencyContact: "Төтенше байланыс",
      emergencyNotSet: "Көрсетілмеген",
      emergencyContactHint: "Маршрутқа тіркелу нысанына әдепкі бойынша қойылады — сол жерде нақты шығу үшін өзгертуге болады.",
      emergencyAddButton: "Қосу",
      emergencyDeleteButton: "Жою",
      emergencyContactSave: "Сақтау",
      emergencyContactCancel: "Бас тарту",
      emergencyContactSaved: "Төтенше байланыс сақталды",
      emergencyContactSaveError: "Төтенше байланысты сақтау мүмкін болмады",
      emergencyContactDeleted: "Төтенше байланыс жойылды",
      emergencyContactDeleteError: "Төтенше байланысты жою мүмкін болмады",
      emergencyDeleteConfirmTitle: "Төтенше байланысты жою керек пе?",
      emergencyDeleteConfirmMessage: "Ол енді маршрутқа тіркелу кезінде әдепкі бойынша қойылмайды.",
      guideTitle: "Не істеу керек, егер…",
      guide: {
        lostTrail: { title: "Жол таппай қалдым", body: "Тоқтаңыз, көрінуді бағалаңыз, соңғы сенімді нүктеге дейін өз ізіңізбен қайтыңыз. Тұманға қарай әрі жылжымаңыз." },
        badWeather: { title: "Ауа-райы нашарлады", body: "Дереу төмен түсіңіз, аңғарларда болыңыз, найзағай кезінде жоталар мен металл заттардан аулақ болыңыз." },
        noSignal: { title: "Байланыс жоқ", body: "Биікке немесе ашық жерге шығыңыз. SMS жіберіп көріңіз — ол әлсіз сигналда да жетеді. Батареяны үнемдеңіз." },
        deadPhone: { title: "Телефон өшіп қалды", body: "Ұшақ режимін қосыңыз, жарықтықты азайтыңыз, GPS-ті қажет болғанша өшіріп қойыңыз. Координаттарыңызды алдын ала төтенше байланыс адамына хабарлаңыз." },
        needHelp: { title: "Көмек керек", body: "112-ге қоңырау шалыңыз. Координаттарыңызды, жағдайыңызды, адам санын хабарлаңыз. Қауіпсіз болса, сол жерде қалыңыз." },
      },
    },
    settings: {
      admin: "Әкімші панелі",
      caption: "Тіл және аккаунт",
      language: "Тіл",
      privacy: "Жекелік",
      privacyOnlyMe: "Тек мен",
      privacyPublic: "Ашық",
      help: "Көмек",
      cookies: "Cookie баптаулары",
      feedback: "Кері байланыс",
      logout: "Шығу",
      linkedAccounts: "Байланыстырылған аккаунттар",
      methodEmail: "Email",
      methodPhone: "Телефон",
      methodTelegram: "Telegram",
      methodGoogle: "Google",
      methodVerified: "расталған",
      methodUnverified: "расталмаған",
      addGoogle: "Google байланыстыру",
      addTelegram: "Telegram байланыстыру",
      linkGenericError: "Байланыстыру мүмкін болмады. Қайталап көріңіз.",
      unlink: "Ажырату",
      unlinkLastMethodError: "Аккаунтқа кірудің соңғы әдісін ажыратуға болмайды",
    },
    language: "Тіл",
    about: "Жоба туралы",
  },

  editProfile: {
    onboardingTitle: "Профильді толтырыңыз",
    onboardingSubtitle: "Бір минут алады — кейбір өрістерді бос қалдыруға болады",
    editTitle: "Профильді өзгерту",
    avatarChange: "Аватарды өзгерту",
    avatarRemove: "Аватарды жою",
    avatarError: "Аватарды жаңарту мүмкін болмады",
    avatarLoadingFromProvider: "Аватар Telegram-нан жүктелуде…",
    cropTitle: "Аватарды кесу",
    cropApply: "Қолдану",
    cropHint: "Аймақты өзгерту үшін рамканы немесе бұрышын сүйреңіз",
    username: "Никнейм",
    usernameRequired: "Никнейм міндетті",
    usernameFormat: "3–30 таңба: кіші латын әріптері, сандар, _",
    usernameReserved: "Бұл никнейм резервте тұр",
    usernameTaken: "Бұл никнейм бос емес",
    firstName: "Аты",
    lastName: "Тегі",
    gender: "Жынысы",
    genderUnset: "Көрсетілмеген",
    genderMale: "Ер",
    genderFemale: "Әйел",
    genderOther: "Басқа",
    birthDate: "Туған күні",
    visibility: "Ашық профиль",
    visibilityHint: "Сілтеме бойынша бөтен адамдар не көретінін анықтайды",
    visibilityPrivate: "Жабық",
    visibilityPublic: "Ашық",
    submitOnboarding: "Жалғастыру",
    submitEdit: "Сақтау",
    saveError: "Профильді сақтау мүмкін болмады",
    consentText: "Мен Пайдаланушы келісімін қабылдаймын және Құпиялылық саясатына сәйкес жеке деректерді жинауға және өңдеуге келісім беремін.",
  },

  publicProfile: {
    routesTitle: "Автор маршруттары",
    routesEmpty: "Әзірге жария маршруттар жоқ",
    notFoundTitle: "Профиль табылмады",
    notFoundSubtitle: "Мұндай пайдаланушы жоқ, немесе сілтеме ескірген",
    private: "Профиль жабық",
  },

  hikeCard: {
    notFoundTitle: "Шығу табылмады",
    notFoundSubtitle: "Мұндай тіркелу жоқ, немесе сілтеме ескірген",
    dates: "Даталар",
    participants: "Қатысушылар",
    track: "Трек",
    emergencyContact: "Шұғыл байланыс",
    footnote: "Бұл шығу туралы ақпарат EcoWay мен Алматы қ. ТЖД пилоттық жобасы аясында берілді. Бұл ТЖМ-де ресми тіркеу болып саналмайды.",
    openOnMap: "Маршрутты картада ашу",
    status: {
      active: "Жүріп жатыр",
      returned: "Аяқталды",
      cancelled: "Болдырылмады",
    },
  },

  routeRegistration: {
    banner: {
      soon: "Тіркелуіңіздің мерзімі жақында аяқталады: {minutes} мин қалды",
      overdue: "Оралу мерзімі өтіп кетті",
      extend: "1 сағатқа ұзарту",
      returned: "Мен оралдым",
      hide: "Жасыру",
      error: "Бір нәрсе дұрыс болмады. Қайталап көріңіз.",
    },
    profile: {
      extendButton: "+1 сағ",
      title: "Маршрутқа тіркелу",
      registerButton: "Маршрутқа тіркелу",
      expectedReturn: "Бақылау уақыты",
      cancelButton: "Болдырмау",
      returnButton: "Мен оралдым",
      cancelConfirmTitle: "Шығуды болдырмайсыз ба?",
      cancelConfirmMessage: "Тіркелу болдырылмайды. Бұл әрекетті кері қайтару мүмкін емес.",
      cancelConfirmButton: "Иә, болдырмау",
      returnConfirmTitle: "Оралғаныңызды белгілейсіз бе?",
      returnConfirmMessage: "Тіркелу аяқталды деп жабылады.",
      returnConfirmButton: "Иә, мен оралдым",
      keepButton: "Қазір емес",
      editButton: "Өзгерту",
      shareButton: "Бөлісу",
      changesSaved: "Өзгерістер сақталды",
      shareText: "Мен жорыққа шықтым және оны ТЖД-да тіркедім.",
      shareCopied: "Сілтеме көшірілді",
      shareCopyError: "Сілтемені көшіру мүмкін болмады",
    },
    form: {
      title: "Маршрутқа тіркелу",
      whyRegister: "Шығуларыңызды тіркеңіз — бұл жорық алдындағы қарапайым әрі негізгі қауіпсіздік шарасы.",
      editTitle: "Тіркелуді өзгерту",
      saveChanges: "Сақтау",
      steps: { route: "Маршрут", dates: "Даталар", contacts: "Байланыстар", confirm: "Растау" },
      stepCounter: "Қадам {n} / {total}",
      changeRoute: "Өзгерту",
      back: "Артқа",
      cancel: "Бас тарту",
      next: "Келесі",
      contactPhone: "Менің телефоным",
      emergencyContactPhone: "Шұғыл байланыс — телефон",
      emergencyContactHint: "Қалада байланыста қалатын адамның телефон нөмірі",
      invalidPhone: "+7XXXXXXXXXX форматында нөмір енгізіңіз",
      route: "Маршрут",
      routeListLabel: "Маршруттар тізімі",
      routeTabSaved: "Таңдаулы",
      routeTabMine: "Менікі",
      routeTabAll: "Барлығы",
      noSavedRoutes: "Таңдаулы әлі жоқ. Маршрутты каталогта сақтаңыз немесе іздеңіз.",
      noOwnRoutes: "Өз маршруттарыңыз әлі жоқ.",
      routeModeDirectory: "Анықтамалықтан",
      routeModeManual: "Қолмен сипаттау",
      routeModeTrack: "Өз треки",
      noRoutesFound: "Маршруттар табылмады",
      routeDescriptionPlaceholder: "Маршрутты өз сөзіңізбен сипаттаңыз",
      trackUploadPrompt: "GPX файлын жүктеу",
      trackExistingFile: "Жүктелген трек",
      trackApproxDistance: "≈ {km} км трек бойынша",
      trackInvalidFile: ".gpx форматындағы файл керек",
      trackTooLarge: "Файл {mb} МБ-тан үлкен",
      trackParseError: "Трек оқылмады — файлды тексеріңіз",
      participants: "Қатысушылар",
      participantsPlaceholder: "Жорыққа қатысушыларды тізіңіз",
      startDate: "Бастау күні",
      expectedReturn: "Оралудың бақылау күні мен уақыты",
      quickHint: "Қайту уақыты маршруттың есептік уақыты бойынша қормен толтырылды. Тексеріп, растаңыз.",
      editDetails: "Мәліметтерді өзгерту",
      consentCombined: "Мен маршрутқа тіркелу шарттарын қабылдаймын және көрсетілген деректерді Алматы қаласының ТЖД-ға өңдеуге және беруге келісемін.",
      consentServiceRulesLink: "«Қауіпсіздік» сервисінің Ережелері",
      consentDchsDataLink: "Деректерді өңдеу және беру келісімі",
      submit: "Тіркелу",
      errorAlreadyActive: "Сізде белсенді тіркелу бар — алдымен соны аяқтаңыз.",
      errorGeneric: "Тіркелуді жіберу мүмкін болмады. Қайталап көріңіз.",
    },
    terms: {
      close: "Түсінікті",
    },
    success: {
      title: "Маршрут тіркелді",
      message: "Маршрутыңыз туралы ақпарат EcoWay-де сақталды және пилот аясында Алматы қ. ТЖД-ға қолжетімді. Жақындарыңызбен жоспарды бөлісіңіз, олар қайда бара жатқаныңызды және қашан оралатыныңызды білсін.",
    },
  },

  aboutProject: {
    backButton: "Артқа",
    navTitle: "Жоба туралы",
    hero: { tagline: "Табиғи маршруттардың тірі картасы" },
    section1: {
      title: "Бірге құратын карта",
      body1: "Ешбір карта өзінен-өзі өзекті болып қала алмайды. Соқпақтар өзгереді. Су пайда болады және жоғалады. Өткелдер қиындайды. Бір жерде учаске шайылады, ал басқа жерде тоқтауға ыңғайлы орын пайда болады.",
      body2: "Сондықтан EcoWay осы маршруттармен жүретін адамдармен бірге дамиды. Маңызды нәрсені байқадыңыз ба — бақылау қосыңыз. Су, соқпақтың жағдайы, өткел, кемпинг, қоқыс немесе басқа өзгеріс — әр белгі жалпы картаны кейін жүретіндерге пайдалырақ етеді.",
      cta: "Бақылау қосу",
    },
    section2: {
      title: "Шығар алдында көбірек көру",
      body1: "EcoWay ақпаратының бір бөлігі тікелей аумақтан келеді. Live-камералар нақты жағдайды көруге көмектеседі, ал нүктелердегі деректер ауа-райы мен жердегі жағдайды түсінуге көмектеседі.",
      body2: "Біз шығар алдында тек болжам немесе маршрут сипаттамасын көру ғана емес, сол жерде шын мәнінде не болып жатқанын көру мүмкін болғанын қалаймыз.",
      cta: "Live көру",
    },
    section3: {
      title: "Жолыңыз туралы ақпарат қалдырыңыз",
      body1: "Қауіпсіздік қарапайым әдеттерден басталады. Шығуларыңызды тіркеп, маршрут жоспарын жақындарыңызбен бөлісіңіз — сіздің қайда бара жатқаныңыз және қашан оралуды жоспарлап отырғаныңыз туралы ақпарат қолжетімді болып қалуы үшін.",
      body2: "EcoWay маршрутқа тіркелу қызметі Алматы қаласының ТЖД-мен бірлесіп пилоттық режимде дамып келеді.",
      cta: "Қауіпсіздік",
    },
    section4: {
      title: "EcoWay енді ғана басталды",
      body1: "Біз жаңа маршруттарды, бақылау нүктелерін және табиғи аумақтардан алынған деректерді біртіндеп қосып жатырмыз.",
      body2: "Біздің мақсатымыз — уақыт өте келе EcoWay шығар алдында маршрут таңдап, нақты жағдайды түсініп, жағдайларға дайындалып, жолыңыз туралы ақпарат қалдыруға болатын орынға айналуы.",
      body3: "Адамдар маршруттарда көрген нәрселерімен бөліскен сайын, бұл сурет соғұрлым дәл болады.",
      closing: "Тірі картаны бірге құрамыз.",
    },
    sponsors: {
      title: "Қолдау көрсеткендер",
      park: "Іле-Алатау мемлекеттік ұлттық табиғи паркі",
      mes: "Алматы қ. ТЖД",
    },
    cta: {
      title: "Қосатын нәрсеңіз бар ма?",
      body: "Дәлсіздік таптыңыз ба, маршрутты білесіз бе, EcoWay үшін жаңа нүкте немесе идея ұсынғыңыз келе ме — бізге айтыңыз.",
      button: "Бізге жазу",
    },
    brandLine: "Жолыңызға сенімді болыңыз",
    contactsTitle: "Байланыстар",
    documents: {
      title: "Құжаттар",
      privacyPolicy: "Құпиялылық саясаты",
      termsOfService: "Пайдаланушы келісімі",
      dataConsent: "Деректерді жинауға және өңдеуге келісім",
      serviceRules: "«Қауіпсіздік» сервисінің ережелері",
      routeDataConsent: "Алматы ТЖД-ға деректер беруге келісім",
      videoGreetingConsent: "EcoWay бейнесәлемдесуін қалыптастыруға және жариялауға келісім (тестілік кезең)",
    },
  },

  legalDocuments: {
    languageLabel: "Құжат тілі",
  },

  camera: {
    live: "LIVE",
    watchStream: "Трансляцияны қарау →",
  },

  map: {
    tools: { button: "Құралдар" },
    contextLost: {
      message: "Бұл құрылғыда карта уақытша қолжетімсіз.",
      retry: "Жаңарту",
    },
    layers: {
      base: "Негізгі карта",
      nodes: "Түйіндер (камералар мен станциялар)",
      routes: "Маршруттар",
      pois: "Маршрут нүктелері",
    },
    locateMe: "Менің орналасуым",
    locateMeApproximate: "Менің орналасуым (болжалды, IP бойынша)",
    northUp: "Солтүстікке бұру",
    compassMode: "Компас бойынша карта",
    toggle3d: "Бедерді қосу (3D)",
    toggle2d: "Бедерді өшіру (2D)",
    layersControl: {
      button: "Карта қабаттары",
      base: "Карта",
      topo: "Топо",
      topo3d: "3D топо",
      poi: "Белгі қабаттары",
      poiGroup: {
        stayWater: "Түнеу және су",
        obstacles: "Кедергілер",
        rest: "Демалыс",
        viewpoint: "Көру алаңдары",
        amenities: "Жайлылықтар",
      },
      poiGroupInfo: {
        stayWater: "Кемпингтер, тау және тұрғын үйшіктер, бұлақтар, құдықтар, су алу орындары, ауыз су, сарқырамалар.",
        obstacles: "Өзен мен бұлақтардағы өткелдер.",
        rest: "Сайбандар, оттықтар, пикник үстелдері.",
        viewpoint: "Көру алаңдары.",
        amenities: "Дәретханалар, қоқыс жәшіктері мен контейнерлер.",
      },
      overlays: "Тақырыптық қабаттар",
      protectedAreas: "Ұлттық саябақтар мен қорықтар",
      routeCoverage: "Соқпақтардың маршруттармен қамтылуы",
      coveragePopupTitle: "Мұндағы маршруттар",
      coverageOpen: "Ашу",
    },
    attribution: {
      title: "Карта деректері",
      button: "Карта деректер көздері туралы",
      close: "Жабу",
      licence: "OpenStreetMap деректері ODbL лицензиясымен қолжетімді.",
    },
    pointTool: {
      button: "Картаға нүкте қою",
      title: "Нүкте",
      close: "Жабу",
      copy: "Координаталарды көшіру",
      copied: "Көшірілді",
      ownMarker: "Өз белгім",
      rename: "Атын өзгерту",
      routesHere: "Осында маршруттар",
      startHere: "Осыдан бастау",
      share: "Бөлісу",
      delete: "Жою",
      loginRequired: "Белгілерді сақтау үшін кіріңіз",
      namePlaceholder: "Белгі атауы",
      kindLabel: "Белгі түрі",
      saveMarker: "Сақтау",
      cancel: "Бас тарту",
      draftExists: "Редакторда жоба бар - осыдан бастау үшін тазалаңыз",
      failed: "Белгіні сақтау мүмкін болмады",
      kind: {
        custom: "Өзім",
        camp: "Түнеу",
        water: "Су",
        viewpoint: "Көру алаңы",
        danger: "Қауіп",
        parking: "Тұрақ",
        other: "Басқа",
      },
    },
    editMode: "Картаны өңдеу",
    debugPanel: "Картаны жөндеу",
    editSaved: "Өзгерістер сақталды",
    editReverted: "Түзету жойылды, бастапқы деректерге қайтарылды",
    editSaveError: "Өзгерістерді сақтау мүмкін болмады",
    ruler: {
      button: "Сызғыш",
      title: "Сызғыш",
      close: "Сызғышты жабу",
      hint: "Нүкте қою үшін картаны басыңыз. Нүкте қосу не өшіру үшін сызықты оң жақ батырмамен немесе ұзақ басыңыз.",
      details: "Сызық сипаттамалары",
      total: "Барлығы",
      gain: "Көтерілу",
      loss: "Төмендеу",
      noElevation: "Биіктік рельеф қамтуынан тыс жерде қолжетімсіз.",
      partialElevation: "Сызықтың бір бөлігі рельеф қамтуынан тыс — қорытынды тек өлшенетін учаскелер бойынша.",
      clear: "Тазалау",
      vertexAria: "Сызғыш нүктесі",
      menuAddPoint: "Осында нүкте қосу",
      menuDeletePoint: "Осы нүктені өшіру",
      menuStraightenLeg: "Кесіндіні түзету",
      menuMagnetizeLeg: "Кесіндіні тартып жеткізу",
      magnet: "Магнит: жолдар мен соқпақтар бойымен құру",
      undo: "Соңғы әрекетті болдырмау",
      redo: "Болдырылмаған әрекетті қайталау",
      routingFallback: "Желі бойынша бағыт табылмады — түзу сызық қолданылды.",
      routeBlocked: "Мұнда салу мүмкін емес: жолда өзен немесе жартас бар — нүкте қосылмады.",
    },
    routeEditor: {
      button: "Маршрут редакторы",
      title: "Маршрут редакторы",
      close: "Редакторды жабу",
      authRequired: "Өз маршруттарыңызды салу және сақтау үшін кіріңіз.",
      modeLine: "Сызық",
      modeWaypoint: "Нүктелер",
      hintLine: "Маршрут салу үшін картаны басыңыз.",
      hintWaypoint: "Таңдалған түрдегі нүкте қою үшін картаны басыңыз.",
      magnet: "Магнит: жолдар мен соқпақтар бойымен құру",
      magnetShort: "Магнит",
      snapWaypointToLine: "Нүктені маршрут сызығына тартып жеткізу",
      undo: "Соңғы әрекетті болдырмау",
      redo: "Болдырылмаған әрекетті қайталау",
      clear: "Барлығын тазалау",
      total: "Барлығы",
      gain: "Көтерілу",
      loss: "Төмендеу",
      duration: "Жол уақыты",
      noElevation: "Биіктік рельеф қамтуынан тыс жерде қолжетімсіз.",
      segments: "Күндер мен кесінділер",
      waypointType: "Нүкте түрі",
      waypointName: "Атауы",
      waypointDescription: "Сипаттама",
      deleteWaypoint: "Нүктені өшіру",
      deleteLastPoint: "Сызықтың соңғы нүктесін өшіру",
      openMine: "Менің маршруттарым",
      newRoute: "Жаңа маршрут",
      save: "Сақтау",
      saveAs: "Былайша сақтау…",
      exportGpx: "GPX форматында экспорттау",
      cancelConfirm: "Өңдеуден бас тарту керек пе? Сақталмаған өзгерістер жоғалады.",
      unsavedTitle: "Редактордан шығасыз ба?",
      routeBlocked: "Мұнда маршрут салу мүмкін емес: жолда өзен немесе жартас бар",
      labelUndo: "Болдырмау",
      labelRedo: "Қайталау",
      labelReverse: "Бұру",
      labelCloseLoop: "Тұйықтау",
      labelLegStraight: "Түзу",
      labelLegRouted: "Соқпақпен",
      labelSnapPoint: "Сызыққа",
      labelInfo: "Кеңестер",
      closeShort: "Жабу",
      actionsLabel: "Бағыт әрекеттері",
      toolsLabel: "Редактор құралдары",
      downloadGpx: "GPX жүктеу",
      importLabel: "Импорт",
      importFromGpx: "GPX-тен",
      importFromCatalogue: "Каталогтан",
      importFromMine: "Менікінен",
      labelNew: "Жаңа",
      hintNew: "Жаңа бағыт",
      hintUndo: "Соңғы әрекетті болдырмау",
      hintRedo: "Болдырылған әрекетті қайталау",
      hintReverse: "Маршрутты бұру: бастау мен аяқтау орындарын ауыстырады",
      hintCloseLoop: "Маршрутты тұйықтау: аяқтаудан бастауға учаске салу",
      hintLegStraight: "Учаске {km} км: түзу. Соқпақпен салу үшін басыңыз",
      hintLegRouted: "Учаске {km} км: соқпақпен. Түзу ету үшін басыңыз",
      hintSnapPoint: "Таңдалған нүктені сызыққа немесе соқпаққа тарту",
      hintInfo: "Кеңестер: әр түйме не істейді",
      onboardingTitle: "Маршрут редакторы",
      onboardingIntro: "Қысқа жадынама. Түйме кеңестері төменгі панельде әрқашан бар: «Әрекеттер» → «Кеңестер».",
      dontShowAgain: "Қайта көрсетпеу",
      gotIt: "Түсінікті",
      onboarding: {
        line: { title: "Сызық", text: "Түймені басып, картаны түртіп маршрут сызыңыз." },
        point: { title: "Нүкте", text: "Түнеу маршрутты күндерге, аялдама күнді учаскелерге бөледі." },
        erase: { title: "Өшіргіш", text: "Сызық төбесін немесе нүктені түртсеңіз, ол өшеді." },
        magnet: { title: "Магнит", text: "Сызық учаскелері соқпақ пен жол бойымен салынады, нүктелер сызыққа және соқпаққа тартылады." },
        edit: { title: "Түзету", text: "Төбелер мен нүктелерді сүйреңіз, нүктені өзгерту үшін түртіңіз, учаскені таңдау үшін сызықты түртіңіз." },
      },
      toolLine: "Сызық",
      toolPoint: "Нүкте",
      toolErase: "Өшіргіш",
      closeWaypoint: "Сақтамай жабу",
      reverse: "Бағытты өзгерту (бастау мен аяқтауды ауыстыру)",
      startLabel: "Старт",
      finishLabel: "Финиш",
      startFinishLabel: "Старт/финиш",
      discard: "Тастау",
      keepEditing: "Жалғастыру",
      clearConfirm: "Салынғанның бәрін тазалау керек пе? Бұл әрекетті болдырмау мүмкін емес.",
      loadError: "Маршрутты өңдеу үшін жүктеу мүмкін болмады.",
      saveError: "Маршрутты сақтау мүмкін болмады.",
      needTwoPoints: "Сақтамас бұрын кемінде екі нүктеден тұратын маршрут салыңыз.",
      unsavedIndicator: "Сақталмаған өзгерістер бар",
      menuFile: "Файл",
      menuNew: "Жаңа",
      menuImport: "Импорттау",
      menuActions: "Әрекеттер",
      menuView: "Түрі",
      viewStatsPanel: "Статистика",
      viewLineStyle: "Сызық стилі",
      viewLineSolid: "Тұтас",
      viewLineGradient: "Градиент",
      viewDirectionArrows: "Бағыт көрсеткілері",
      view3d: "3D көрініс",
      tabProfile: "Профиль",
      tabStats: "Статистика",
      namePlaceholder: "Маршрутқа атау беріңіз",
      profileTitle: "Биіктік профилі",
      sectionsTitle: "Секциялар",
      addWaypointDialog: {
        typeMarker: "Белгі",
        markerHint: "Картадағы жеке жазба - тек сізге көрінеді, «Менің белгілерім» ішінде. Маршрутқа кірмейді.",
        title: "Жаңа нүкте",
        confirm: "Қосу",
      },
      importDialog: {
        title: "Маршрутты импорттау",
        close: "Жабу",
        tabMine: "Менікі",
        tabFavorites: "Таңдаулылар",
        tabPublic: "Ашық",
        tabGpx: "GPX файлы",
        emptyMine: "Сізде әлі маршрут жоқ",
        emptyFavorites: "Таңдаулылар тізімі бос",
        emptyPublic: "Маршруттар табылмады",
        uploadButton: "GPX файлын таңдау…",
        uploadHint: "GPX форматындағы файл (.gpx)",
        importError: "GPX файлын оқу мүмкін болмады",
      },
      saveDialog: {
        titleNew: "Маршрутты сақтау",
        titleExisting: "Өзгерістерді сақтау",
        name: "Атауы",
        namePlaceholder: "Мысалы, «Көк-Жайляу үстірт арқылы»",
        description: "Сипаттама",
        descriptionPlaceholder: "Маршрут туралы қысқаша — міндетті емес",
        tags: "Тегтер",
        tagsPlaceholder: "үтірмен бөлек",
        visibility: "Көрінуі",
        visibilityHint: "Ашық — каталогта барлығына көрінеді, жеке — тек сізге",
        public: "Ашық",
        private: "Жеке",
        cancel: "Бас тарту",
        confirm: "Сақтау",
        nameRequired: "Маршрут атауын көрсетіңіз",
      },
    },
  },

  captive: {
    welcomeTitle: "Қош келдіңіз",
    welcomeSubtitle: "Интернетке шығу үшін «Қосылу» түймесін басыңыз",
    connectButton: "Қосылу",
    defaultNodeName: "Мыңжылқы",
    metersShort: "м",
    windUnit: "м/с",
    precipUnit: "мм",
    wave: {
      heading: "Биіктіктен сәлем жібер",
      body: "Камера сәтіңізді түсіреді — біз оны бейнеашықхатқа айналдырамыз.",
      step1: "Қол бұлғаңыз",
      step2: "Уақытты есте сақтаңыз",
      step3: "Өтінім жіберіңіз",
      cta: "Өз ашықхатыңды ал",
    },
    amenities: {
      title: "Геошатыр «Высота Кусто»",
      body: "Демалыңыз, телефоныңызды зарядтаңыз және байланысқа шығыңыз.",
    },
    visitors: {
      per30days: "30 күндегі қонақтар саны",
      today: "Бүгін",
    },
    routesLinkTitle: "Жақындағы маршруттар картасы",
    satelliteNote: "Интернет спутниктік байланыс арқылы жұмыс істейді. Үнемдеп пайдаланыңыз.",
  },

  tgRegister: {
    title: "Шығуды тіркеу",
    openInTelegram: "Форманы боттан ашыңыз",
    openInTelegramHint: "Бұл бет тек Telegram ішінде жұмыс істейді: EcoWay ботында «Маршрутты тіркеу» батырмасын басыңыз.",
    loading: "Жүктелуде…",
    authError: "Telegram арқылы кіру мүмкін болмады. Форманы жауып, боттан қайта ашыңыз.",
    retry: "Қайталау",
    close: "Жабу",
    active: {
      title: "Сізде белсенді тіркеу бар",
      extendHour: "Бір сағатқа ұзарту",
      extended: "Бақылау уақыты ұзартылды",
      actionError: "Сәтсіз аяқталды. Қайталап көріңіз.",
    },
    returned: {
      title: "Қош келдіңіз!",
      message: "Тіркеу жабылды. Бәрі жақсы болғанына қуаныштымыз.",
      newRegistration: "Жаңа тіркеу",
    },
    success: {
      reminders: "Бот қайту уақыты туралы еске салады — сол жерде оны ұзартуға немесе белгі қоюға болады.",
    },
  },
};
